export default __webpack_public_path__ + "static/slide_3-474b1c854d9c2d3cbc84009b489c486c.png";